import React from "react";

export function SecondaryContent({ type, noteId, noteTitle, commentSnippet, message }) {
  if (type === "nearby_note") {
    // Personalized (has noteId): show the note title
    // Legacy bulk (no noteId): show the message ("5 new notes near you")
    const displayText = noteId ? noteTitle : message;
    if (!displayText) return null;
    return (
      <div className="mt-0.5 text-sm text-text-secondary line-clamp-1">
        {noteId ? <>{"\u201C"}{displayText}{"\u201D"}</> : displayText}
      </div>
    );
  }
  if (type === "like") {
    const displayText = noteTitle;
    if (!displayText) return null;
    return (
      <div className="mt-0.5 text-sm text-text-secondary line-clamp-1">
        {"\u201C"}{displayText}{"\u201D"}
      </div>
    );
  }
  return (
    <>
      {commentSnippet && (
        <div className="mt-0.5 text-sm text-text-secondary italic line-clamp-2">
          {"\u201C"}{commentSnippet}{"\u201D"}
        </div>
      )}
      <div className="mt-0.5 text-xs text-text-muted line-clamp-1">
        on {"\u201C"}{noteTitle}{"\u201D"}
      </div>
    </>
  );
}
